export const DOWNLOAD_TYPE_ENUM = {
LIFE_INSURANCE :"Life Insurance",
 MEDICAL_INSURANCE : "Medical Insurance",
 STAFF_INSURANCE :"Staff Insurance (PA Cover)",
 SHOP_INSURANCE : "Shop Insurance",
 TREE_PLANTATION :"Tree Plantation",
 ANNUAL_TRIP_CONFIRMATION :"Annual Trip Confirmation",
}